import Link from "next/link";
import { createContext } from "react";
export var MenuContext = createContext({
    linkComponent: Link
});
